import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ScaleLoader from "react-spinners/ScaleLoader";

import { useStyles } from "./CustomLoader.css";

class CustomLoader extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.loader}>
        <ScaleLoader
          color="black"
          height={80}
          width={8}
          radius={10}
          margin={8}
          loading={true}
        />
      </div>
    );
  }
}

export default withStyles(useStyles)(CustomLoader);
